import { Observable } from 'rxjs';

import Entity from '../../../core/domain/entity';
import UniqueEntityID from '../../../core/domain/unique_entity_id';
import { HelpMeCategories } from '../../../ui/help-me/help-me-categories';
import { AttachmentUpload } from './attachment-upload';

export interface MessageAttachmentHelpProps {
  name: string;
  path: string;
  size: number;
  mimeType: string;
  status: 'init' | 'started' | 'completed' | undefined;
  url?: string | undefined;
  file?: File | undefined;
  upload?: AttachmentUpload | undefined;
  progress?: Observable<number | undefined>;
  error?: any | undefined;
}

export interface BaseMessageHelpProps {
  createdAt: Date;
  content: string;
  attachments?: MessageAttachmentHelpProps[] | undefined;
}

export interface MessageThreadHelpProps extends BaseMessageHelpProps {
  supportReply: boolean;
}

export interface MessageHelpProps extends BaseMessageHelpProps {
  dietitianId?: string | undefined;
  dietitianFullName: string | undefined;
  category: HelpMeCategories;
  answered: boolean;
  closed: boolean;
  thread?: MessageThreadHelpProps[] | undefined;
}

export class MessageHelpId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): MessageHelpId {
    return new MessageHelpId(id);
  }
}

export class MessageHelp extends Entity<MessageHelpProps> {
  get messageHelpId(): MessageHelpId {
    return MessageHelpId.create(this.id);
  }

  get dietitianId(): string | undefined {
    return this.props.dietitianId;
  }

  get dietitianFullName(): string | undefined {
    return this.props.dietitianFullName;
  }

  get createdAt(): Date {
    return this.props.createdAt;
  }

  get category(): HelpMeCategories {
    return this.props.category;
  }

  get content(): string {
    return this.props.content;
  }

  get attachments(): MessageAttachmentHelpProps[] | undefined {
    return this.props.attachments;
  }

  get thread(): MessageThreadHelpProps[] | undefined {
    return this.props.thread;
  }

  set thread(value: MessageThreadHelpProps[] | undefined) {
    this.props.thread = value;
  }

  get answered(): boolean {
    return this.props.answered;
  }

  set answered(value: boolean) {
    this.props.answered = value;
  }

  get closed(): boolean {
    return this.props.closed;
  }

  set closed(value: boolean) {
    this.props.closed = value;
  }

  private constructor(props: MessageHelpProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: MessageHelpProps): MessageHelp {
    return MessageHelp.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(
    props: MessageHelpProps,
    id?: UniqueEntityID,
  ): MessageHelp {
    return new MessageHelp(props, id);
  }
}
